const ChevronRight = ({ stroke = "#000", strokeWidth = 1 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12.021"
      height="12.021"
      viewBox="0 0 12.021 12.021"
    >
      <path
        id="Rectangle_Copy_22"
        data-name="Rectangle Copy 22"
        d="M8,0V8H0"
        transform="translate(0 6.01) rotate(-45)"
        fill="none"
        stroke={stroke}
        strokeMiterlimit="10"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export default ChevronRight;
